export const required = (value) => {
  let error;
  if (!value) error = 'Поле должно быть заполнено';
  return error;
};
